import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createNumericTransformer, createTimestampTransformer } from '../common/sql';
import {
  ComposableUnitSchema,
  DBComposableUnitSchema,
  DBQuestionSetItemSchema,
  DBQuestionSetMarksSchema,
  DBQuestionSetSchema,
  DBQuestionSetTypeTagSchema,
  QuestionSetItemSchema,
  QuestionSetMarksSchema,
  QuestionSetSchema,
  QuestionSetTypeTagSchema,
} from './schemas';

export const QuestionSetCodecConfig: TransformerConfig<
  typeof QuestionSetSchema,
  typeof DBQuestionSetSchema
> = {
  name: 'QuestionSet',
  clientSchema: QuestionSetSchema,
  dbSchema: DBQuestionSetSchema,
  transformers: [
    createNumericTransformer<typeof QuestionSetSchema, typeof DBQuestionSetSchema>('randomSeed', {
      nullable: true,
    }),
    createTimestampTransformer<typeof QuestionSetSchema, typeof DBQuestionSetSchema>(
      'publishedAt',
      { nullable: true }
    ),
    createTimestampTransformer<typeof QuestionSetSchema, typeof DBQuestionSetSchema>('createdAt'),
    createTimestampTransformer<typeof QuestionSetSchema, typeof DBQuestionSetSchema>('updatedAt', {
      nullable: true,
    }),
  ],
};

export const QuestionSetItemCodecConfig: TransformerConfig<
  typeof QuestionSetItemSchema,
  typeof DBQuestionSetItemSchema
> = {
  name: 'QuestionSetItem',
  clientSchema: QuestionSetItemSchema,
  dbSchema: DBQuestionSetItemSchema,
  transformers: [
    createTimestampTransformer<typeof QuestionSetItemSchema, typeof DBQuestionSetItemSchema>(
      'createdAt'
    ),
  ],
};

export const QuestionSetTypeTagCodecConfig: TransformerConfig<
  typeof QuestionSetTypeTagSchema,
  typeof DBQuestionSetTypeTagSchema
> = {
  name: 'QuestionSetTypeTag',
  clientSchema: QuestionSetTypeTagSchema,
  dbSchema: DBQuestionSetTypeTagSchema,
  transformers: [
    createTimestampTransformer<typeof QuestionSetTypeTagSchema, typeof DBQuestionSetTypeTagSchema>(
      'createdAt'
    ),
  ],
};

export const QuestionSetMarksCodecConfig: TransformerConfig<
  typeof QuestionSetMarksSchema,
  typeof DBQuestionSetMarksSchema
> = {
  name: 'QuestionSetMarks',
  clientSchema: QuestionSetMarksSchema,
  dbSchema: DBQuestionSetMarksSchema,
  transformers: [],
};

export const ComposableUnitCodecConfig: TransformerConfig<
  typeof ComposableUnitSchema,
  typeof DBComposableUnitSchema
> = {
  name: 'ComposableUnit',
  clientSchema: ComposableUnitSchema,
  dbSchema: DBComposableUnitSchema,
  transformers: [],
};

export const encodeQuestionSetToDb = createEncodeToDbFn(QuestionSetCodecConfig);
export const decodeQuestionSetFromDb = createDecodeFromDbFn(QuestionSetCodecConfig);
export const encodeQuestionSetItemToDb = createEncodeToDbFn(QuestionSetItemCodecConfig);
export const decodeQuestionSetItemFromDb = createDecodeFromDbFn(QuestionSetItemCodecConfig);
export const encodeQuestionSetTypeTagToDb = createEncodeToDbFn(QuestionSetTypeTagCodecConfig);
export const decodeQuestionSetTypeTagFromDb = createDecodeFromDbFn(QuestionSetTypeTagCodecConfig);
export const decodeQuestionSetMarksFromDb = createDecodeFromDbFn(QuestionSetMarksCodecConfig);
export const decodeComposableUnitFromDb = createDecodeFromDbFn(ComposableUnitCodecConfig);
